import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  floors: {
    height: "55px",
    borderLeft: `1px solid ${theme.palette.border.default}`,
    borderRight: `1px solid ${theme.palette.border.default}`,
    borderRadius: 0,
    paddingLeft: "16px",
    paddingRight: "16px",
    textDecoration: "none",
    color: theme.palette.text.primary,

    [theme.breakpoints.down("lg")]: {
      width: "unset",
      fontSize: "12px",
    },
  },
  btnText: {
    alignItems: "center",
    textDecoration: "none",
    color: theme.palette.text.primary,
    "&:hover": {
      color: theme.palette.text.primary,
      textDecoration: "none",
    },
  },
  menuPopover: {
    marginTop: theme.spacing(6),
    width: "400px",
    border: `1px solid ${theme.palette.border.default}`,
    boxShadow: "2px 4px 20px 0px #0000001A",
    maxHeight: "calc(100% - 70px)",
    borderRadius: "8px",
  },
  container: { overflow: "hidden" },
  floorNumber: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 24,
    height: 24,
    borderRadius: "100%",
    marginRight: 10,
    border: `2px solid ${theme.palette.events.blueSecondary}`,
  },
  headerContainer: {
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
    borderBottom: `1px solid ${theme.palette.border.default}`,
  },
  button: {
    cursor: "pointer",
    color: theme.palette.events.blueSecondary,
  },
  floorContainer: {
    maxHeight: "50px",
    borderBottom: `1px solid ${theme.palette.border.default}`,
  },
  youAreHere: {
    textAlign: "center",
    borderRadius: "5px",
    width: "100px",
    padding: "5px 10px",
    backgroundColor: theme.palette.border.default,
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
  },
  switchFloorButton: {
    cursor: "pointer",
  },
  switchButton: {
    textDecoration: "none",
    color: theme.palette.events.blueSecondary,
    fontWeight: 400,
  },
  unfoldIcon: {
    marginLeft: theme.spacing(0.5),
  },
  floorName: {},
  guestCount: {
    fontSize: "12px",
    color: theme.palette.events.grayTertiary,
    fontWeight: 400,
    lineHeight: "15.62px",
  },
  buttons: {
    height: "24px",
    gap: "10px",
    display: "flex",
  },
}));
